import React, { useMemo } from 'react';
import RFQStatusLayout from 'components/common/rfq/RFQStatusLayout';
import BrowsingReviewCarriersPageStore, {
  PageStoreContext,
  useBrowsingReviewCarriersPageStore,
} from 'store/pages/rfq/initiate-rfq/browsing-review-carriers/pageStore';
import InfoBlob from 'components/rfq/initiate-rfq/browsing-review-carriers/InfoBlob';
import { observer } from 'mobx-react-lite';
import PageHeader from 'components/common/general/layouts/PageHeader';
import { bpHistory } from 'global/bpHistory';
import { PortfoliosByCarriersTable } from 'components/rfq/initiate-rfq/browsing-review-carriers/PortfoliosByCarriersTable';
import PageFooter from 'components/common/general/layouts/PageFooter';
import useRfqQuoteUrlParams from 'global/hooks/useRfqQuoteUrlParams';
import {
  getRFQProposalChecklistURL,
  RFQ_PROPOSAL_CARD_DATA,
} from 'global/checklists-helpers/RFQProposalChecklistHelper';

const BrowsingReviewCarriersContent: React.FC = observer(() => {
  const { saveCarriersSelection, isLoading } = useBrowsingReviewCarriersPageStore();
  const { periodId, cartId } = useRfqQuoteUrlParams();

  function redirectToChecklist(): void {
    bpHistory.push(getRFQProposalChecklistURL({ periodId, cartId }));
  }

  return (
    <>
      <PageHeader
        subtitleMaxWidth="75rem"
        title={RFQ_PROPOSAL_CARD_DATA.INITIATE_BROWSING_CARRIERS.title}
        subtitle={RFQ_PROPOSAL_CARD_DATA.INITIATE_BROWSING_CARRIERS.text}
        onRedirect={redirectToChecklist}
      />
      <InfoBlob />
      <PortfoliosByCarriersTable />
      <PageFooter
        onBack={redirectToChecklist}
        completeButtonText="Complete"
        onComplete={saveCarriersSelection}
        disableCompleteButton={isLoading}
      />
    </>
  );
});

const BrowsingReviewCarriersPage: React.FC = () => {
  const { periodId, cartId } = useRfqQuoteUrlParams();

  const pageStore = useMemo(() => new BrowsingReviewCarriersPageStore({ periodId, cartId }), []);

  return (
    <RFQStatusLayout>
      <PageStoreContext.Provider value={pageStore}>
        <BrowsingReviewCarriersContent />
      </PageStoreContext.Provider>
    </RFQStatusLayout>
  );
};

export default BrowsingReviewCarriersPage;
